// Styles for PhoneNumberField go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { theme } from '@marriott/mi-ui-library-shop';
export const StyledPhoneNumberField = styled.div`
  .blurred {
    position: absolute;
    z-index: 4;
    width: 100%;
    height: 125%;
    opacity: 0.5;
    background-color: ${baseVariables.color['base20']};
    top: ${toRem(-10)};
  }
  .inputtext-field {
    max-width: 304px;
    flex: 1;
    input {
      height: 32px !important;
      padding: 0px 5px 0px 15px !important;
    }
    .is-error {
      border-color: var(--t-form-error-color) !important;
    }
  }
  .country-label {
    z-index: 1;
  }
  .country-code-dropdown {
    height: ${toRem(45)};
    width: 100%;
    border-radius: ${toRem(4)} !important;
    border-color: ${baseVariables.color['base10']} !important;
  }
  .country-code-dropdown.is-disabled {
    border-color: ${baseVariables.color['neutral40']} !important;
  }
  .country-code-dropdown .icon-dropdown-down,
  .country-code-dropdown .icon-dropdown-up {
    position: absolute;
    right: ${toRem(8)};
  }

  .m-dropdown-field {
    border: 1px solid;
    width: 124px;
    height: 32px;
    padding: 5px;
    font-size: 14px;
  }
  .error {
    border: 1px solid var(--t-form-error-color) !important;
  }
  @media ${theme.mediaQuery.allMobiles} {
    .error-position {
      position: absolute !important;
    }
  }

  .custom-select-wrapper {
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      padding-right: 30px;
      position: relative;
      font-family: inherit;
      width: 107px;
      height: 32px;
      font-weight: 400;
      color: var(--t-brand-fg-color);
    }
  }

  .custom-select-wrapper {
    position: relative;
    display: inline-block;
  }

  .custom-select-wrapper::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    top: 43%;
    right: 10%;
    border-left: 2px solid var(--t-brand-fg-color);
    border-bottom: 2px solid var(--t-brand-fg-color);
    transform: rotate(-45deg) translateY(-50%);
    pointer-events: none;
    transition: transform 0.3s;
  }
`;
